/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var _excluded = ["children", "tabIndex"];

/**
 * `ListBoxField` is responsible for creating the containing node for valid
 * elements inside of a field. It also provides a11y-related attributes like
 * `role` to make sure a user can focus the given field.
 */
var ListBoxField = function ListBoxField(_ref) {
  var children = _ref.children,
    tabIndex = _ref.tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "button",
    className: "cds--list-box__field",
    tabIndex: tabIndex
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, rest), children);
};
ListBoxField.propTypes = {
  children: PropTypes.node,
  tabIndex: PropTypes.string
};
ListBoxField.defaultProps = {
  tabIndex: '0',
  children: undefined
};
var ListBoxField$1 = ListBoxField;

export { ListBoxField$1 as default };
